import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import { globalQueryClient } from '@/queries/queryClient'
import type { Response } from '@/types/response'

import { getPublicResponse, getResponse } from './services/loadResponses'

export const useLoadResponse = (
  id: string,
  options: Omit<
    UseQueryOptions<Response, Error, Response, [string, { id: string }]>,
    'queryKey' | 'queryFn'
  > = {}
): UseQueryResult<Response, Error> => {
  return useQuery({
    queryKey: [QUERIES.RESPONSES.GET, { id }],
    queryFn: () => getResponse(id),
    ...options,
  })
}

export const useLoadPublicResponse = (
  code: string,
  params?: { packetMessageCode?: string | null },
  options: Omit<
    UseQueryOptions<
      Response,
      Error,
      Response,
      [
        string,
        {
          code: string
          params: { packetMessageCode?: string | null } | undefined
        },
      ]
    >,
    'queryKey' | 'queryFn'
  > = {}
): UseQueryResult<Response, Error> => {
  return useQuery({
    queryKey: [QUERIES.RESPONSES.GET_PUBLIC, { code, params }],
    queryFn: () => {
      return getPublicResponse(code, params)
    },
    ...options,
  })
}

export const invalidateLoadResponses = async (id?: string) => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.RESPONSES.GET, { id }],
    exact: false,
  })

  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.RESPONSES.GET_PUBLIC],
    exact: false,
  })
}
